$.fn.fessSearchResultsPlugin = function (options) {
    var pluginName = 'fessSearchResultsPlugin',
        appBaseUrl = $('#spsearchtext-fess').attr('data-search-url');

    // Here we need to have a list of Corporate and Railcargo sites. If we add new sites, we need to add them to this list

    var presentationsites = [
        'ÖBB-BCC',
        'ÖBB-Holding',
        'ÖBB-Immobilien',
        'ÖBB-Infrastruktur',
        'ÖBB-Karriere',
        'ÖBB-Konzern',
        'ÖBB-Personenverkehr',
        'ÖBB-Presse',
        'ÖBB-Produktion',
        'ÖBB-Technische Services',
        'ÖBB-Werbung',
        'Rail Cargo Group',
        'Rail Cargo Logistics',
        'Rail Cargo Operator',
        'ROLA',
        'WS-Service',
        'Rail Cargo Hungaria',
        'Rail Equipment',
        'SNNB',
        'Hauptbahnhofcity',
        'BahnhofCity',
        'BahnhofCity Innsbruck',
        'BahnhofCity Wien West',
        'BahnhofCity Wels',
        'BahnhofCity Linz',
        'ÖBB-Ferienhaus',
        'ÖBB-Operative Services',
        'ÖBB-Wohnen',
        'ÖBB Opendata',
        'Rail4Future',
        'ÖBB Bildungscampus',
        'ÖBB-Bahnhof',
        'ÖBB-Infra Bildungsprogramm',
    ];

    var labelsites = [
        'corpbccsearch',
        'corpholdingsearch',
        'corpimmosearch',
        'corpinfrasearch',
        'corpkarrieresearch',
        'corpkonzernsearch',
        'corppvsearch',
        'corppressesearch',
        'corpproduktionsearch',
        'corptssearch',
        'corpwerbungsearch',
        'corprcgsearch',
        'corprclsearch',
        'corprcosearch',
        'corprolasearch',
        'corpwsssearch',
        'corprchsearch',
        'corprailequipmentsearch',
        'corpsnnbsearch',
        'corphauptbahnhofcitysearch',
        'corpbahnhofcitysearch',
        'corpbahnhofcityinnsbrucksearch',
        'corpbahnhofcitywienwestsearch',
        'corpbahnhofcitywelssearch',
        'corpbahnhofcitylinzsearch',
        'corpferienhaussearch',
        'corpossearch',
        'corpwohnensearch',
        'corpopendatasearch',
        'corprail4futuresearch',
        'corpbildungscampussearch',
        'corpbahnhofsearch',
        'corpbildungsprogrammsearch',
    ];

    // default options.
    var settings = $.extend(
        {
            // These are the defaults.
            serviceBaseUrl: appBaseUrl + '/search',
            serviceFullUrl: null,
            lang: 'de',
        },
        options,
    );

    function formatDate(dateInMilliseconds) {
        var date = new Date(dateInMilliseconds);
        var day = date.getDate();
        var dateDay = day < 10 ? '0' + day : day;

        var month = date.getMonth() + 1;
        var dateMonth = month < 10 ? '0' + month : month;

        var dateYear = date.getFullYear();

        return dateDay + '.' + dateMonth + '.' + dateYear;
    }

    function renderEmptyResultCount(that) {
        var hitsWord = that.attr('data-hits-word');
        var htmlToAppend = '<p>0 ' + hitsWord + '</p>';
        that.append(htmlToAppend);
    }

    function renderEmptyResultWord(that) {
        var noResultsWord = that.attr('data-no-results-word');
        var searchKeyword = $('#spsearchtext-fess').attr('data-search-keyword');
        var htmlToAppend = '<div class="text-block"><p>' + noResultsWord + ' ' + searchKeyword + '.</p></div>';
        that.append(htmlToAppend);
    }

    // Do something to each element here.
    return this.each(function () {
        var that = $(this);

        var loadingWord = that.attr('data-loading-word');
        var $loader = $(document.createElement('div'));
        $loader.addClass('sp-loader');
        $loader.append(`
            <div class="loader"></div>
            <p>${loadingWord}</p>
        `);
        $loader.hide();
        that.append($loader);

        var hitsWord = that.attr('data-hits-word');
        var companyWord = that.attr('data-company-word');
        var lastUpdateWord = that.attr('data-last-updated-word');
        var documentTypeWord = that.attr('data-document-type-word');
        var errorOccurredWord = that.attr('data-error-occurred-word');

        var maxResults = $('#spsearchtext-fess').attr('data-max-results');
        var searchCluster = $('#spsearchtext-fess').attr('data-search-cluster');
        var searchKeyword = $('#spsearchtext-fess').attr('data-search-keyword');

        var searchPresentationWebsite = $('#spsearchtext-fess').attr('data-search-presentation-website');
        var searchPresentationWebsiteIndex = presentationsites.indexOf(searchPresentationWebsite);
        var searchWebsite = labelsites[searchPresentationWebsiteIndex];
        var documentTypeKeyword = $('#spsearchtext-fess').attr('data-search-filetype');
        var timeKeyword = $('#spsearchtext-fess').attr('data-search-time');
        var allWebsitesWord = $('#spsearchtext-fess').attr('data-all-websites-word');
        var allDocumentTypesWord = $('#spsearchtext-fess').attr('data-all-document-types-word');
        var isTabbed = $('#fess-search-results').hasClass('tab-container');

        var url = settings.serviceBaseUrl + '/' + searchCluster;
        if (settings.serviceFullUrl) url = settings.serviceFullUrl;

        var params = new URLSearchParams(location.search);
        var paramQuery = params.get('q');
        if (paramQuery === null) {
            return;
        }
        if (paramQuery !== null && paramQuery.trim() === '') {
            renderEmptyResultCount(that);
            return;
        }

        $loader.show();
        $.getJSON(
            url +
                '?q=' +
                encodeURIComponent(searchKeyword) +
                '&lang=' +
                settings.lang +
                (searchWebsite ? '&sites=' + searchWebsite : '') +
                (documentTypeKeyword ? '&filetype=' + documentTypeKeyword : '') +
                (timeKeyword ? '&time=' + timeKeyword : '') +
                '&maxResults=' +
                maxResults,
            function (data) {
                var uniqueFilter = function (value, index, that) {
                    return that.indexOf(value) === index;
                };

                var searchResults = data.hits;
                var filetypes = $.map(searchResults, function (elem) {
                    return elem.filetype.toUpperCase();
                }).filter(uniqueFilter);
                var labels = $.map(searchResults, function (elem) {
                    return elem.label;
                })
                    .filter(uniqueFilter)
                    .sort();
                var sites = [];

                for (let i = 0; i < labels.length; i++) {
                    const label = labels[i];
                    const index = labelsites.indexOf(label);

                    sites.push({
                        label: label,
                        site: presentationsites[index],
                    });
                }

                sites.sort(function (a, b) {
                    return a.site.toLowerCase().localeCompare(b.site.toLowerCase());
                });

                $loader.hide();

                if (searchResults.length === 0) {
                    renderEmptyResultCount(that);
                    renderEmptyResultWord(that);
                    return;
                }

                if (isTabbed) {
                    for (let i = 0; i < sites.length; i++) {
                        let pair = sites[i];
                        const hitsCount = searchResults.filter(item => item.label[0] === pair.label).length;

                        let htmlToAppend = '<li role="region">';
                        htmlToAppend += '<h3 class="tab-headline">' + pair.site + ' (' + hitsCount + ')</h3>';
                        ``;

                        htmlToAppend += '<div><ul class="search-result-list">';

                        for (var z = 0; z < data.hits.length; z++) {
                            var result = data.hits[z];

                            if (result.label == pair.label) {
                                htmlToAppend += '<li class="search-result-item">';
                                htmlToAppend += '<div class="search-result-item-title">';
                                htmlToAppend += '<a title="' + result.title + '" href="' + result.url + '">';
                                htmlToAppend += '<span class="ic-arrow2-right" aria-hidden="true"></span>' + result.title + '</a></div>';
                                htmlToAppend += '<div class="search-result-item-excerpt">' + result.content + '</div>';
                                htmlToAppend += '<div class="search-result-item-url">' + result.url + '</div></li>';
                            }
                        }

                        htmlToAppend += '</div></ul></li>';
                        $('#fess-search-results .search-tabs').append(htmlToAppend);
                    }

                    if (labels.length == 0) {
                        $('#fess-search-results .search-tabs').append('<div class="text-block"><p>' + noResultsWord + ' ' + searchKeyword + '.</p></div>');
                    }

                    $('#fess-search-results .search-tabs').attr('aria-busy', 'false');
                    $('#fess-search-results .search-tabs').tabsPlugin();
                } else {
                    //fills the websites dropdown
                    $('#sp-company').append(
                        '<option value="" ' + (searchPresentationWebsite == '' ? "selected='selected'" : '') + '>' + allWebsitesWord + '</option>',
                    );
                    for (i in sites) {
                        const pair = sites[i];
                        $('#sp-company').parent().parent().removeClass('sp-select-hidden');
                        $('#sp-company').append(
                            '<option value="' +
                                pair.site +
                                '" ' +
                                (searchPresentationWebsite == pair.site ? "selected='selected'" : '') +
                                '>' +
                                pair.site +
                                '</option>',
                        );
                    }

                    // fills the filetypes dropdown
                    $('#sp-doctype').append(
                        '<option value="" ' + (documentTypeKeyword == '' ? "selected='selected'" : '') + '>' + allDocumentTypesWord + '</option>',
                    );
                    for (i in filetypes) {
                        $('#sp-doctype').parent().parent().removeClass('sp-select-hidden');
                        $('#sp-doctype').append(
                            '<option value="' +
                                filetypes[i] +
                                '" ' +
                                (documentTypeKeyword == filetypes[i] ? "selected='selected'" : '') +
                                '>' +
                                filetypes[i] +
                                '</option>',
                        );
                    }

                    // fills the search results
                    if (searchResults.length > 0) {
                        var htmlToAppend = '<p>' + searchResults.length + ' ' + hitsWord + '</p>';
                        htmlToAppend += '<ul class="search-result-list">';

                        for (i in searchResults) {
                            var result = searchResults[i];
                            var url = result.url;

                            htmlToAppend += '<li class="search-result-item">';
                            htmlToAppend += '<div class="search-result-item-title">';
                            htmlToAppend += '<a href="' + url + '">';
                            htmlToAppend += '<span class="ic-arrow2-right" aria-hidden="true"></span>' + result.title + '</a></div>';
                            htmlToAppend += '<div class="search-result-item-criterion">';
                            htmlToAppend +=
                                '<span class="search-simple-text">' +
                                companyWord +
                                ': </span>' +
                                presentationsites[labelsites.indexOf(result.label[0])] +
                                ' - ';
                            htmlToAppend += '<span class="search-simple-text">' + documentTypeWord + ': </span>' + result.filetype.toUpperCase() + ' - ';
                            htmlToAppend += '<span class="search-simple-text">' + lastUpdateWord + ': </span>' + formatDate(result.modifiedDate) + '</div>';
                            htmlToAppend += '<div class="search-result-item-excerpt">' + result.content + '</div>';
                            htmlToAppend += '<div class="search-result-item-url">' + url + '</div></li>';
                        }

                        htmlToAppend += '</ul>';
                        that.append(htmlToAppend);
                    }
                }
            },
        ).fail(function () {
            var htmlToAppend = '<p>' + errorOccurredWord + '</p>';
            that.append(htmlToAppend);
            $loader.hide();
        });
    });
};
